import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayText',
  standalone: true,
})
export class DisplayTextPipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    limit = 20,
    placeholder = '--',
    trail = '...',
  ): string {
    if (!value || value.trim().length === 0) {
      return placeholder;
    }

    // Remove spaces for length calculation, but preserve original for display
    const nonSpaceLength = value.replace(/ /g, '').length;
    if (nonSpaceLength > limit) {
      let count = 0;
      let result = '';
      for (const char of value) {
        if (char !== ' ') {
          count++;
        }
        result += char;
        if (count >= limit) {
          break;
        }
      }
      return result + trail;
    }

    return value;
  }
}
